const getSubmissionErrors = (error) =>
  error?.response?.data?.errors?.map((err) => ({ name: err.param, message: err.msg }))

export default getSubmissionErrors
